<script setup>
import WebsiteTable from '@frontJs/components/tables/projectManagement/dev/WebsiteTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

const { phpVersions } = defineProps({
    phpVersions: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Sites web - DEV - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - DEV - Sites web </PageTitle>

    <TabLayout
        :tabs="{
            all: {
                title: 'Tous',
                content: h(WebsiteTable, { phpVersions }),
            },
            magento1: {
                title: 'Magento 1',
                content: h(WebsiteTable, {
                    phpVersions,
                    cms: 'magento1',
                    openmage: false,
                }),
            },
            openmage: {
                title: 'OpenMage',
                content: h(WebsiteTable, {
                    phpVersions,
                    cms: 'magento1',
                    openmage: true,
                }),
            },
            magento2: {
                title: 'Magento 2',
                content: h(WebsiteTable, { phpVersions, cms: 'magento2' }),
            },
            prestashop: {
                title: 'PrestaShop',
                content: h(WebsiteTable, { phpVersions, cms: 'prestashop' }),
            },
            shopify: {
                title: 'Shopify',
                content: h(WebsiteTable, { cms: 'shopify' }),
            },
            wordpress: {
                title: 'Wordpress',
                content: h(WebsiteTable, { phpVersions, cms: 'wordpress' }),
            },
            laravel: {
                title: 'Laravel',
                content: h(WebsiteTable, { phpVersions, cms: 'laravel' }),
            },
            nextJs: {
                title: 'Next.js',
                content: h(WebsiteTable, { phpVersions, cms: 'nextjs' }),
            },
            static: {
                title: 'Statique',
                content: h(WebsiteTable, { phpVersions, cms: 'static' }),
            },
        }"
    />
</template>
